import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { useEffect } from "react"

export default defineView("single-film", (props) => {
  const urlRedirect = props.film?.filmData?.urlRedirect

  // Film links already point to the URL Redirect; this covers visits to the film's own URL.
  useEffect(() => {
    if (urlRedirect) window.location.replace(urlRedirect)
  }, [urlRedirect])

  if (urlRedirect) return null

  return <ContentBlocks blocks={props.film?.contentBlocks || []} />
})
